import { createReducer, Action, on } from '@ngrx/store';

import { HeadingActions } from './heading.actions';
import { HeadingState } from './heading.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: HeadingState = {
  loading: false,
  headingStatistics: {},
  headings: [],
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(HeadingActions.LoadSuggestions, (state) => ({ ...state, loading: true, error: undefined })),
    on(HeadingActions.LoadSuggestionsSuccess, (state, action) => ({
      ...state,
      loading: false,
      headingStatistics: action.listStatistics,
      headings: action.list,
    })),
    on(HeadingActions.LoadSuggestionsFail, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),
    on(HeadingActions.SetMode, (state, action) => ({ ...state, mode: action.mode }))
  )
);

export function reducer(state: HeadingState | undefined, action: Action) {
  return featureReducer(state, action);
}
